<div class="error-message" *ngIf="errorEmail || telefonoError || showImageErrorMessage">Hay campos con un formato incorrecto.</div>
<div class="error-message" *ngIf="(showEtiquetaError || showIdentificadorError) && !(errorEmail || telefonoError || showImageErrorMessage)">Por favor, rellena los campos obligatorios.</div>
<div class="ok-message fade-out" *ngIf="!errorEmail && !showEtiquetaError && !telefonoError && !showIdentificadorError &&
establecimientoCreado && !errorFinal">El establecimiento se ha creado correctamente.</div>
<div class="error-message fade-out" *ngIf="errorFinal">{{errorFinalMessage}}</div>

<div class="container">
    <div class="header">
        <div class="header-content">
            <span class="font20">NUEVO ESTABLECIMIENTO</span>
            <button mat-icon-button matTooltip="Registrar nuevo establecimiento" class="gurdar-btn" (click)="guardarDispositivo()" [disabled]="waitAfterSave">
                <mat-icon>save</mat-icon>
            </button>
        </div>
        <span class="header-text" class="font14">Formulario de alta de establecimientos DataBeer</span>
    </div>
    <div class="body">

        <!--DISPOSITIVO-->

        <div class="datos-dispositivo">

            <div class="datos-dispositivo-header">
                <span>DATOS DEL ESTABLECIMIENTO</span>
            </div>

            <div class="margin20">
                <span class="custom-label">Identificador Único: </span>
                <mat-form-field class="form-field-custom">
                    <mat-label [ngClass]="{'error-select': showIdentificadorError}">Identificador del Establecimiento</mat-label>
                    <input matInput type="text" [(ngModel)]="identificador" placeholder="Identificador único del usuario" 
                    value="{{this.establecimientoActual.dev_label}}" required>
                    <button *ngIf="identificador" matSuffix mat-icon-button aria-label="Clear" (click)="identificador=''">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>
                <mat-error *ngIf="showIdentificadorError" class="custom-error">Introduzca un identificador</mat-error>
            </div>
            
            <div class="marginBottom10">
                <span class="custom-label">Nombre: </span>
                <mat-form-field class="form-field-custom">
                    <mat-label [ngClass]="{'error-select': showEtiquetaError}">Nombre de Establecimiento</mat-label>
                    <input matInput type="text" [(ngModel)]="etiqueta" placeholder="Nombre de una localidad, parroquia, nucleo, etc..." 
                    value="{{this.establecimientoActual.dev_label}}" required>
                    <button *ngIf="etiqueta" matSuffix mat-icon-button aria-label="Clear" (click)="etiqueta=''">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>
                <mat-error *ngIf="showEtiquetaError" class="custom-error">Introduzca una etiqueta</mat-error>
            </div>

            <div *ngIf="userData.pro_id == 4" class="marginBottom10">
                <span class="custom-label1">Cliente:</span><span> En caso de no seleccionar ninguno se asignará el cliente del propio usuario.</span>
                <mat-form-field class="form-field-custom">
                    <mat-label>-Elige una opción-</mat-label>
                    <mat-select [(value)]="selectedCliente" name="est">
                      <mat-option *ngFor="let est of clientes" [value]="est.value">
                        {{est.name}}
                      </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            
            <div class="custom-container">
                <div class="referencia-container width48">
                    <span class="custom-label">País </span>
                    <mat-form-field appearance="outline" class="latitud-value marginTop10 " *ngIf="addressData.country">
                        <input matInput type="text" [readonly]="true" value="{{addressData.country}}"/>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="latitud-value marginTop10" *ngIf="!addressData.country">
                        <input matInput type="text" [readonly]="true" value="No hay datos disponibles"/>
                    </mat-form-field>
                </div>
    
                <div class="referencia-container widht48-custom">
                    <span class="custom-label">Comunidad Autónoma</span>
                    <mat-form-field appearance="outline" class="latitud-value marginTop10 " *ngIf="addressData.administrative_area_level_1">
                        <input matInput type="text" [readonly]="true" value="{{addressData.administrative_area_level_1}}"/>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="latitud-value marginTop10 " *ngIf="!addressData.administrative_area_level_1">
                        <input matInput type="text" [readonly]="true" value="No hay datos disponibles"/>
                    </mat-form-field>
                </div>
            </div>

            <div class="custom-container">
                <div class="referencia-container width48">
                    <span class="custom-label">Provincia </span>
                    <mat-form-field appearance="outline" class="latitud-value marginTop10 " *ngIf="addressData.administrative_area_level_2">
                        <input matInput type="text" [readonly]="true" value="{{addressData.administrative_area_level_2}}"/>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="latitud-value marginTop10 " *ngIf="!addressData.administrative_area_level_2">
                        <input matInput type="text" [readonly]="true" value="No hay datos disponibles"/>
                    </mat-form-field>
                </div>
    
                <div class="referencia-container widht48-custom">
                    <span class="custom-label">Localidad </span>
                    <mat-form-field appearance="outline" class="latitud-value marginTop10 " *ngIf="addressData.locality">
                        <input matInput type="text" [readonly]="true" value="{{addressData.locality}}"/>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="latitud-value marginTop10 " *ngIf="!addressData.locality">
                        <input matInput type="text" [readonly]="true" value="No hay datos disponibles"/>
                    </mat-form-field>
                </div>
            </div>

            <div class="referencia-container">
                <span class="custom-label">Dirección: </span><span> Calle y número</span>
                <mat-form-field appearance="outline" class="latitud-value marginTop10 " *ngIf="addressData.route && addressData.street_number"> 
                    <input matInput type="text" [readonly]="true" value="{{addressData.route}}, {{addressData.street_number}}"/>
                </mat-form-field>
                <mat-form-field appearance="outline" class="latitud-value marginTop10 " *ngIf="addressData.route && !addressData.street_number"> 
                    <input matInput type="text" [readonly]="true" value="{{addressData.route}}"/>
                </mat-form-field>
                <mat-form-field appearance="outline" class="latitud-value marginTop10 " *ngIf="!addressData.route && addressData.street_number"> 
                    <input matInput type="text" [readonly]="true" value="{{addressData.street_number}}"/>
                </mat-form-field>
                <mat-form-field appearance="outline" class="latitud-value marginTop10 " *ngIf="!addressData.route && !addressData.street_number"> 
                    <input matInput type="text" [readonly]="true" value="No hay datos disponibles"/>
                </mat-form-field>
            </div>

            <div class="referencia-container">
                <span class="custom-label">Código Postal </span>
                <mat-form-field appearance="outline" class="latitud-value marginTop10 " *ngIf="addressData.postal_code">
                    <input matInput type="text" [readonly]="true" value="{{addressData.postal_code}}"/>
                </mat-form-field>
                <mat-form-field appearance="outline" class="latitud-value marginTop10 " *ngIf="!addressData.postal_code">
                    <input matInput type="text" [readonly]="true" value="No hay datos disponibles"/>
                </mat-form-field>
            </div>

            <!--<div class="estado-container">
                <span class="titulos-dispositivo">Cerveza: </span> <span> Tipos de cerveza</span>
                <mat-form-field class="form-field-custom">
                    <mat-label>-Elige una opción-</mat-label>
                    <mat-select [formControl]="cervezasControl" name="est" multiple>
                      <mat-option *ngFor="let est of cervezas" [value]="est.value">
                        {{est.name}}
                      </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>-->

            <div class="estado-container">
                <span class="custom-label">Estado: *</span>
                <mat-form-field class="form-field-custom">
                    <mat-label>-Elige una opción-</mat-label>
                    <mat-select [(value)]="selectedEstado" name="est">
                      <mat-option *ngFor="let est of estado" [value]="est.value">
                        {{est.name}}
                      </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="imagen-container">
                <div>
                    <span class="titulos-dispositivo" [ngClass]="{'error-select': showImageErrorMessage}">Imagen: </span>
                    <span [ngClass]="{'error-select': showImageErrorMessage}">Imagen del establecimiento (solo JPG).</span>
                </div>
                <div>
                    <button type="button" mat-raised-button (click)="fileInput.click()" class="boton-imagen">Elige una imagen</button>
                    <span *ngIf="file !== undefined" class="marginleft10">{{file.name}}</span>
                </div>
                <input hidden #fileInput type="file" id="image_uploads" (change)="onFileSelected($event)" accept="image/jpeg" class="imagen-custom">
                <!--<div class="showImageErrorMessage-container" style="margin-top: 12px;">
                    <span *ngIf="showImageErrorMessage" style="color: rgba(255, 0, 0, 0.993); font-size: 14px;">Por favor, seleccione un archivo .jpg</span>
                </div>-->
                <img *ngIf="imageUrl" [src]="imageUrl" alt="Vista previa de imagen establecimiento" class="imagen-dispositivo">
                <!--<img *ngIf="!imageUrl" src={{est_img_path}} alt="Vista previa de imagen establecimiento" class="imagen-dispositivo">-->
                <mat-error *ngIf="showImageErrorMessage" class= "marginTop10 ">Por favor, seleccione un archivo .jpg</mat-error>
            </div>

        </div>

        <div class="datos-instalacion">

            <div class="datos-instalacion-header">
                <span>UBICACIÓN DEL ESTABLECIMIENTO</span>
            </div>

            <div class="buscador-container custom">
                <input class="form-control custom3" type="text" [(ngModel)]="searchPlace" id="pac-input" placeholder="Buscar en el mapa..."/>
            </div>
            <div class="mapa-container">
                <!--<agm-map [latitude]="lat" [longitude]="lng" [zoom]="zoom" [mapTypeControl]="true" mapTypeId="hybrid" (mapClick)="onChoseLocation($event)">
                    <agm-marker [latitude]="lat" [longitude]="lng"></agm-marker>
                </agm-map>-->
                <div id="map" class="height450"></div>
            </div>

            <mat-form-field class="lat-container custom">
                <mat-label class="label-text">Latitud</mat-label>
                <input matInput type="number" [(ngModel)]="lat" placeholder="Selecciona la latitud" value="{{lat}}" (ngModelChange)="updateLocation()">
                <button matSuffix mat-icon-button aria-label="Clear" (click)="refresh()">
                    <mat-icon>refresh</mat-icon>
                </button>
            </mat-form-field>

            <mat-form-field class="lng-container widht100">
                <mat-label class="label-text">Longitud</mat-label>
                <input matInput type="number" [(ngModel)]="lng" placeholder="Selecciona la latitud" value="{{lng}}" (ngModelChange)="updateLocation()">
                <button matSuffix mat-icon-button aria-label="Clear" (click)="refresh()">
                    <mat-icon>refresh</mat-icon>
                </button>
            </mat-form-field>

            <!--DATOS DE CONTACTO-->

            <div class="datos-contacto-header">
                <span>DATOS DE CONTACTO</span>
            </div>

            <form [formGroup]="signin">
                <mat-form-field class="etiqueta-container" class="margin20">
                    <mat-label class="label-text">Contacto</mat-label>
                    <input matInput type="text" placeholder="Nombre de contacto" formControlName="contacto">
                    <button *ngIf="contactoInput?.value" matSuffix mat-icon-button aria-label="Clear" (click)="clearField('contacto')">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>
            </form>

            <form [formGroup]="signin">
                <mat-form-field class="input-container2 widht100">
                    <mat-label class="label-text" [ngClass]="{'error-select': telefonoError}">Teléfono</mat-label>
                    <input matInput placeholder="600 00 00 00" formControlName="telefono" mask="000 00 00 00">
                    <mat-icon matPrefix>phone</mat-icon>
                    <button *ngIf="telefonoInput?.value" matSuffix mat-icon-button aria-label="Clear" (click)="clearField('telefono')">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>
                <mat-error *ngIf="telefonoError" class="custom1">El número de teléfono introducido no es correcto.</mat-error>
            </form>

            <form [formGroup]="signin">
                <mat-form-field class="input-container2 widht100">
                    <mat-label class="label-text" [ngClass]="{'error-select': errorEmail}">Correo electrónico</mat-label>
                    <input matInput placeholder="Ejemplo: usuarionombre@perfectnumbers.tech" formControlName="email">
                    <button *ngIf="emailInput?.value" matSuffix mat-icon-button aria-label="Clear" (click)="clearField('email')">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>
                <mat-error *ngIf="errorEmail" class="custom2">Introducizca un email válido</mat-error>
            </form>

        </div>
    </div>
</div>
<div class="footer"></div>

